import { useMachine } from '@xstate/react';
import React from 'react';
import { BaseResponse } from '../../machine';
import { BaseComponent, BaseComponentProps, Input } from '../types';
import { InvokerMachine } from './InvokerMachine';
import { SpinnerLoader } from './Loader';

export interface InvokerProps {
  logo?: string;
  currentParentState: string;
  element?: BaseComponent;
  elementProps: BaseComponentProps;
  onRenderLoader?: () => JSX.Element;
  onSubmit?: (stateName: string, inputs: Input[]) => Promise<void>;
  onError?: (error: Error) => void;
  onSuccess?: (response: BaseResponse) => void;
  showErrorMessage?: boolean;
}

export const Invoker = (props: InvokerProps): JSX.Element => {
  const { onSuccess, onSubmit, currentParentState } = props;
  const [current, send] = useMachine(InvokerMachine);

  const handleOnSubmit = async (inputs: Input[]): Promise<void> => {
    send('INVOKE');
    try {
      onSubmit && (await onSubmit(currentParentState, inputs));
      onSuccess && onSuccess({ data: inputs });
    } catch (error) {
      send('FAILURE');
    }
    send('SUCCESS');
  };

  if (current.matches('idle')) {
    return props.element ? (
      <props.element {...props.elementProps} onSubmit={handleOnSubmit} />
    ) : (
      <></>
    );
  } else if (current.matches('loading')) {
    return props.onRenderLoader ? props.onRenderLoader() : <SpinnerLoader />;
  } else if (current.matches('failure')) {
    if (props.showErrorMessage === true) {
      return props.onRenderLoader ? props.onRenderLoader() : <SpinnerLoader />;
    } else {
      return props.onRenderLoader ? props.onRenderLoader() : <SpinnerLoader />;
      // <RemoteMessage
      //   logo={logo}
      //   text="An unknown error occurred. Please try again later."
      // />
    }
  }
  return <></>;
};
